import { DsButton as DesignSystemButton } from "@equipmentshare/ds-button";
import * as Icon from "@equipmentshare/ds-icon";
import React from "react";
import styled from "styled-components";

import * as Animation from "~/Animation";

export const Component: Component<{
  readonly title: string;
  readonly icon?: Icon.IconProps["name"];
  readonly disabled?: boolean;
  readonly action?: boolean;
  readonly neutral?: boolean;
  readonly danger?: boolean;
  readonly primary?: boolean;
  readonly secondary?: boolean;
  readonly blank?: boolean;
  readonly onClick?: () => void;
}> = ({
  title,
  icon,
  disabled,
  action,
  neutral,
  danger,
  primary,
  secondary,
  blank,
  ...props
}) => (
  <Button.Component
    title={title}
    iconName={icon}
    isDisabled={disabled}
    intent={
      action ? "action" : neutral ? "neutral" : danger ? "danger" : undefined
    }
    variant={
      primary
        ? "primary"
        : secondary
        ? "secondary"
        : blank
        ? "blank"
        : undefined
    }
    {...props}
  />
);

namespace Button {
  export const Component = styled(DesignSystemButton)`
    ${() => Animation.Transition.styles(Animation.fast())}
  `;
}
